// frontend/src/pages/Admin/Users.jsx
import { useState, useEffect } from 'react';
import { getAdminUsers } from '../../api/services';

export default function AdminUsers() {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState('');
    const [page, setPage] = useState(1);

    useEffect(() => {
        fetchUsers();
    }, [page, search]);

    const fetchUsers = async () => {
        try {
            const params = { page, per_page: 20 };
            if (search) params.search = search;

            const { data } = await getAdminUsers(params);
            setUsers(data.items || []);
        } catch (error) {
            console.error('Failed to fetch users:', error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-[400px]">
                <svg className="animate-spin h-10 w-10 text-brand-amber" viewBox="0 0 24 24" fill="none">
                    <circle className="opacity-20" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" />
                    <path className="opacity-80" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
                </svg>
            </div>
        );
    }

    return (
        <div>
            <h1 className="font-display text-2xl font-bold text-brand-text mb-6">Users</h1>

            <div className="mb-4">
                <input
                    type="text"
                    placeholder="Search users by name or email…"
                    value={search}
                    onChange={(e) => { setPage(1); setSearch(e.target.value); }}
                    className="input-field max-w-md"
                />
            </div>

            <div className="card p-0 overflow-hidden">
                <table className="min-w-full">
                    <thead>
                        <tr className="border-b border-brand-border">
                            <th className="px-6 py-3 text-left text-xs font-medium text-brand-muted uppercase tracking-widest font-body">Email</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-brand-muted uppercase tracking-widest font-body">Name</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-brand-muted uppercase tracking-widest font-body">Plan</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-brand-muted uppercase tracking-widest font-body">Superuser</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-brand-muted uppercase tracking-widest font-body">Created</th>
                        </tr>
                    </thead>
                    <tbody>
                        {users.map((user) => (
                            <tr key={user.id} className="border-b border-brand-border last:border-0 hover:bg-brand-surface/50 transition-colors">
                                <td className="px-6 py-4 text-sm text-brand-text font-body">{user.email}</td>
                                <td className="px-6 py-4 text-sm text-brand-text font-body">{user.first_name} {user.last_name}</td>
                                <td className="px-6 py-4 text-sm text-brand-muted font-body capitalize">{user.plan_tier}</td>
                                <td className="px-6 py-4 text-sm">
                                    {user.is_superuser
                                        ? <span className="text-brand-amber font-body text-xs">Yes</span>
                                        : <span className="text-brand-muted font-body text-xs">No</span>}
                                </td>
                                <td className="px-6 py-4 text-sm text-brand-muted font-body">{new Date(user.created_at).toLocaleDateString()}</td>
                            </tr>
                        ))}
                        {users.length === 0 && (
                            <tr>
                                <td colSpan={5} className="px-6 py-10 text-center text-brand-muted font-body text-sm">
                                    {search ? 'No users match your search.' : 'No users yet.'}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Pagination */}
            <div className="flex items-center justify-between mt-4">
                <button
                    onClick={() => setPage((p) => Math.max(1, p - 1))}
                    disabled={page === 1}
                    className="btn-ghost text-sm py-2 px-4 disabled:opacity-40 disabled:cursor-not-allowed"
                >
                    Previous
                </button>
                <span className="text-brand-muted font-body text-sm">Page {page}</span>
                <button
                    onClick={() => setPage((p) => p + 1)}
                    disabled={users.length < 20}
                    className="btn-ghost text-sm py-2 px-4 disabled:opacity-40 disabled:cursor-not-allowed"
                >
                    Next
                </button>
            </div>
        </div>
    );
}